'use client'

import { cn } from '../../utils/cn'
import type { TimelineProps, TimelineNode } from './types'

function NodeDot({ status }: { status: TimelineNode['status'] }) {
  return (
    <div className={cn(
      'flex items-center justify-center w-6 h-6 rounded-full border-2 shrink-0 z-10',
      status === 'completed' && 'bg-primary/20 border-primary',
      status === 'active' && 'bg-primary border-primary',
      status === 'error' && 'bg-destructive/20 border-destructive',
      status === 'pending' && 'bg-card border-border',
    )}>
      {status === 'completed' && <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" className="text-primary"><polyline points="20 6 9 17 4 12" /></svg>}
      {status === 'active' && <div className="w-2 h-2 rounded-full bg-primary-foreground animate-pulse" />}
      {status === 'error' && <span className="text-[9px] font-bold text-destructive">!</span>}
    </div>
  )
}

export function Timeline({ nodes, className }: TimelineProps) {
  return (
    <div className={cn('space-y-0', className)}>
      {nodes.map((node, i) => (
        <div key={node.id} className="flex gap-4 relative">
          {/* Vertical line */}
          {i < nodes.length - 1 && (
            <div className={cn(
              'absolute left-3 top-8 w-0.5 h-[calc(100%-8px)]',
              node.status === 'completed' ? 'bg-primary/30' : 'bg-border',
            )} />
          )}
          <NodeDot status={node.status} />
          <div className={cn('pb-8 pt-0.5', i === nodes.length - 1 && 'pb-0')}>
            <h4 className={cn('text-sm font-semibold', node.status === 'pending' ? 'text-muted-foreground' : 'text-foreground')}>
              {node.label}
            </h4>
            {node.description && <p className="text-xs text-muted-foreground mt-0.5">{node.description}</p>}
            {node.timestamp && <span className="text-[10px] text-muted-foreground/50 font-mono mt-1 block">{node.timestamp}</span>}
          </div>
        </div>
      ))}
    </div>
  )
}
